import remarkGfm from 'remark-gfm';

export const onebriefRemarkPlugins = [remarkGfm];
export const inlineAllowedElements = ['a', 'strong', 'em', 'code', 'del', 'br', 'span'];
